import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search, Command, Menu } from "lucide-react";
import ProfileMenu from "./ProfileMenu";
import CommandPalette from "./CommandPalette";
import LanguageSwitcher from "./LanguageSwitcher";

export default function TopBar({ onOpenMobileMenu }) {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      if ((isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <div className="sticky top-0 z-30 -mx-4 sm:-mx-6 lg:-mx-10 px-4 sm:px-6 lg:px-10 py-3 lg:py-4 bg-ink-0/80 backdrop-blur-xl border-b border-white/5 flex items-center gap-3">
        {/* Mobile: hamburger */}
        <button
          data-testid="mobile-menu-btn"
          onClick={onOpenMobileMenu}
          className="lg:hidden shrink-0 p-2 -ml-2 rounded-lg text-zinc-400 hover:text-white hover:bg-white/5"
          style={{ transitionProperty: "color, background-color", transitionDuration: "180ms" }}
          aria-label={t("topbar.openMenu")}
        >
          <Menu className="w-5 h-5" strokeWidth={1.75} />
        </button>

        <button
          data-testid="topbar-search"
          onClick={() => setPaletteOpen(true)}
          className="flex-1 min-w-0 max-w-xl flex items-center gap-3 px-3 sm:px-4 py-2 rounded-lg bg-white/[0.03] border border-white/[0.08] hover:bg-white/[0.06] hover:border-white/15 text-left group"
          style={{ transitionProperty: "background-color, border-color", transitionDuration: "180ms" }}
        >
          <Search className="w-4 h-4 text-zinc-500 shrink-0" strokeWidth={1.75} />
          <span className="flex-1 min-w-0 truncate text-sm text-zinc-500">
            <span className="hidden sm:inline">{t("topbar.search")}</span>
            <span className="sm:hidden">{t("topbar.searchShort")}</span>
          </span>
          <span className="hidden sm:flex items-center gap-1 text-[11px] text-zinc-500">
            <kbd className="border border-white/10 rounded px-1.5 py-0.5 flex items-center gap-0.5">
              <Command className="w-3 h-3" strokeWidth={2} />
              <span>K</span>
            </kbd>
          </span>
        </button>
        <div className="hidden sm:block flex-1" />
        <LanguageSwitcher compact />
        <ProfileMenu />
      </div>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </>
  );
}
